<template>
    <section>
      <iframe src="" ref="modelEngine" class="model_engine"></iframe>
    </section>
</template>
<script>
    export default {
        name: "ModelEngine",
      props:{
          model:null
      },
      mounted() {
        let index = this.model.modelUrl.lastIndexOf('/');
        let file = this.model.modelUrl.substring(index+1,this.model.modelUrl.length-4);
        this.$refs.modelEngine.src = "/modelengine?file="+file +"&modelId="+this.model.id;
      }
    }
</script>

<style scoped>
  .model_engine{ border: 0;width: 100%; height: 760px;}
</style>



// WEBPACK FOOTER //
// src/components/model/ModelEngine.vue